module.exports = global["moment"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?moment!./~/moment-timezone/index.js
// module id = 836
// module chunks = 0